import { useSyncExternalStore } from 'react';

import { fileIdFromUrl } from '../lib/disk-trash';

/**
 * Файлы из текста статьи, которых больше нет (удалены с Диска → в Корзине, вложение удалено).
 * Список приходит с карточкой статьи (`deletedFileIds`); карточка файла в редакторе по нему
 * помечает себя «Файл удалён» и даёт кнопку «Убрать». Тело статьи и Yjs здесь не трогаем.
 * Хранилище на уровне модуля, потому что карточка — узел Tiptap (рендерится вне дерева ArticlePage),
 * а открытая статья в редакторе всегда одна.
 */
let deletedIds: ReadonlySet<string> = new Set();
const listeners = new Set<() => void>();

export function setDeletedFileIds(ids: ReadonlyArray<string> | null | undefined): void {
  const next = new Set((ids ?? []).map((id) => id.toLowerCase()));
  if (next.size === deletedIds.size && [...next].every((id) => deletedIds.has(id))) return;
  deletedIds = next;
  listeners.forEach((fn) => fn());
}

function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

/** true — файл, на который ведёт адрес карточки, удалён. */
export function useIsFileDeleted(url: string | null | undefined): boolean {
  const id = fileIdFromUrl(url);
  return useSyncExternalStore(
    subscribe,
    () => (id ? deletedIds.has(id) : false),
    () => false,
  );
}
